import React, { type ReactNode } from 'react'
import { Tab } from '@headlessui/react'
import { twMerge } from 'tailwind-merge'

interface PageTabProps extends Record<string, unknown> {
  children: React.ReactNode
  className?: string
}

export const PageTab = ({ children, className, ...props }: PageTabProps): ReactNode => {
  return (
    <Tab
      className={({ selected }) =>
        twMerge(
          selected ? `border-b-brand-primary text-text-primary` : `border-b-transparent`,
          `w-fit border-b-2 px-4 py-6 outline-hidden main-transition-colors sm:px-5`,
          className,
        )
      }
      {...props}
    >
      <span className="font-inter font-bold whitespace-nowrap sm:text-[17px]">{children}</span>
    </Tab>
  )
}
